/**
 * Public blog display flags.
 *
 * SHOW_BLOG_POST_DATES — while the site is newly launched, every post carries a
 * publish date within the same few days, which makes the blog look brand-new.
 * We keep the dates in the database (they still drive ordering, scheduling, and
 * the admin views) but hide them from the PUBLIC post header, index cards, and
 * the JSON-LD `datePublished` (so a date can't surface in search results)
 * until the site has been live long enough that dated posts read naturally.
 *
 * Flip this to `true` to restore visible dates everywhere — no data migration
 * or backfill needed; the dates were never removed.
 */
export const SHOW_BLOG_POST_DATES: boolean = false;
